/* eslint-disable react/no-array-index-key */
import React from 'react';

import { times } from 'helpers/utils';
import './skeleton.scss';

const TableSkeleton = ({ num = 1 }: { num: number }) => {
  return (
    (<div className="tableWrapper" data-palette="TableSkeleton">
      <table className="table">
        <tbody>
          {times(num).map((_, i) => (
            <tr key={i} data-palette="TableSkeleton">
              <td className="loading">
                <div className="bar" />
              </td>
              <td className="loading">
                <div className="bar" />
              </td>
              <td className="loading">
                <div className="bar" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>)
  );
};

export default TableSkeleton;
